import clsx from 'clsx';

import { ButtonLink } from '@commons/components/Button';
import RichText from '@commons/components/RichText';
import Texture from '@commons/components/Texture';
import Flex from '@commons/containers/Flex';
import type { DrupalLink, DrupalParagraph } from '@commons/types/drupal';
import type { Theme } from '@commons/types/styles';

import styles from './index.module.scss';

// Type definition for the TexturedTile paragraph properties.

type Props = DrupalParagraph & {
  content: string;
  theme: Theme;
  animated: boolean;
  button?: DrupalLink;
};

/**
 * TexturedTile paragraph component.
 */

const TexturedTileParagraph = ({ content, theme, animated, button }: Props) => {
  const renderedButton = button ? (
    <ButtonLink variant="secondary" href={button.url}>
      {button.text}
    </ButtonLink>
  ) : null;

  const classes = clsx(styles.texturedTile, 'w-100', 'h-100');

  return (
    <Flex
      gap="sm"
      width={12}
      theme={theme}
      padding="sm"
      justify="space-between"
      direction="column"
      className={classes}
    >
      <RichText value={content} width={12} className={styles.content} />
      {renderedButton}
      <Texture animated={animated} />
    </Flex>
  );
};

export default TexturedTileParagraph;
